var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFtmView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 276,
    viewBox: "0 0 229 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.571 38.12V275.37H192.321H196.161H228.871V242.65V38.12H59.571Z",
    fill: "#080E04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.011 30.56V267.81H184.761H188.601H221.311V235.09V30.56H52.011Z",
    fill: "#6CCA36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.451 23V260.25H177.201H181.041H213.751V227.53V23H44.451Z",
    fill: "#E8FFDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.437 103.558C118.103 114.891 118.103 133.266 129.437 144.6C140.77 155.934 159.145 155.934 170.479 144.6C181.813 133.267 181.813 114.892 170.479 103.558C159.146 92.2235 140.771 92.2235 129.437 103.558",
    stroke: "black",
    strokeWidth: 2.3217,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.72 106.841C123.2 116.361 123.2 131.796 132.72 141.316C142.24 150.837 157.675 150.837 167.195 141.316C176.716 131.796 176.716 116.361 167.195 106.841C157.675 97.3208 142.24 97.3205 132.72 106.841",
    stroke: "black",
    strokeWidth: 2.3217,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.332 105.488C139.058 107.023 135.442 109.981 133.092 113.866C130.741 117.751 129.799 122.327 130.424 126.824",
    stroke: "black",
    strokeWidth: 2.32168,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.894 104.885C152.385 104.232 149.774 104.082 147.208 104.443",
    stroke: "black",
    strokeWidth: 2.32168,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.495 153.352L120.697 145.554L87.8958 178.355L95.6942 186.153L128.495 153.352Z",
    stroke: "black",
    strokeWidth: 2.3217,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6708 177.53L95.6901 179.573L121.925 153.338",
    stroke: "black",
    strokeWidth: 2.32168,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.596 149.438L129.982 144.074",
    stroke: "black",
    strokeWidth: 2.32168,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2914 97.2292L91.5466 18.5311C92.1139 17.5016 91.1178 16.3189 90.0068 16.6961L5.95384 45.232C5.71949 45.3117 5.51313 45.4573 5.35952 45.6514C5.20592 45.8455 5.11161 46.0798 5.08792 46.3262C5.06422 46.5726 5.11215 46.8206 5.22595 47.0404C5.33975 47.2602 5.51458 47.4425 5.72945 47.5654L34.329 63.8428C34.6027 63.9984 34.8098 64.2489 34.9109 64.547L45.9469 97.0236C46.307 98.0818 47.7532 98.2092 48.2914 97.2292Z",
    fill: "#BADEAC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2914 83.2292L92.5466 4.5311C93.1139 3.50164 92.1178 2.31891 91.0068 2.69609L6.95384 31.232C6.71949 31.3117 6.51313 31.4573 6.35952 31.6514C6.20592 31.8455 6.11161 32.0798 6.08792 32.3262C6.06422 32.5726 6.11215 32.8206 6.22595 33.0404C6.33975 33.2602 6.51458 33.4425 6.72945 33.5654L35.329 49.8428C35.6027 49.9984 35.8098 50.2489 35.9109 50.547L46.9469 83.0236C47.307 84.0818 48.7532 84.2092 49.2914 83.2292Z",
    fill: "#6CCA36"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44482 33.4476C4.19041 32.6995 4.23168 31.8825 4.5602 31.1639C4.73307 30.7809 4.98341 30.4379 5.29542 30.1564C5.60744 29.875 5.97438 29.6612 6.37311 29.5287L90.4282 0.992066C90.827 0.854029 91.2501 0.800511 91.6707 0.834916C92.0913 0.869321 92.5002 0.990897 92.8712 1.19191C93.5646 1.5635 94.0912 2.18437 94.3446 2.92913C94.4827 3.33306 94.5342 3.76154 94.4957 4.18669C94.4573 4.61183 94.3297 5.02412 94.1214 5.39672L50.8664 84.0955C50.5793 84.6208 50.1454 85.051 49.6176 85.3336C49.0898 85.6161 48.4912 85.7387 47.8948 85.6864C47.2985 85.6341 46.7303 85.4092 46.2598 85.039C45.7893 84.6689 45.4369 84.1697 45.2456 83.6024L34.2718 51.3091L5.83939 35.1277C5.1846 34.7572 4.68841 34.1594 4.44482 33.4476ZM90.337 4.81858L8.60687 32.5659L36.2182 48.281C36.8738 48.6538 37.3697 49.2542 37.6121 49.9684L48.2753 81.3467L90.337 4.81858Z",
    fill: "#080E04"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtmView);
export default __webpack_public_path__ + "static/media/ftm-view.568404d386d89334502d6ae5ff187676.svg";
export { ForwardRef as ReactComponent };